import { COOKIE_VISITOR_ID } from '@config/constants'

import { getCorrelationId, refreshCorrelationIdCookie } from './helpers'

export const getVisitorId = (cookies) =>
  getCorrelationId(cookies, COOKIE_VISITOR_ID)

export const refreshVisitorIdCookie = (visitorId, res) => {
  refreshCorrelationIdCookie(COOKIE_VISITOR_ID, visitorId, res)
}
